import axios from "axios";
import BaseUrl from "../utils/BaseUrl";

const { base } = BaseUrl();

const api = axios.create({ baseURL: base });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("_token_");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
